module.exports = __webpack_public_path__ + "img/c04_unitbatteringram_Normal_ua.b1c5669c.webp";